import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const FullTextTooltip = styled.a`
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-decoration: underline;
  position: relative;
  z-index: 100;
  max-width: 100px;

  & > span {
    padding: 10px;
    border-radius: 5px;
  }

  &:hover,
  &:focus {
      overflow: visible;

      & > span {
        background-color: ${props => props.background};
      }
    }
  }
`;

function SourceLink({ link, background }) {
  return (
    <FullTextTooltip
      background={background}
      href={link}
      target="_blank"
      onClick={e => e.stopPropagation()}
    >
      <span>{link}</span>
    </FullTextTooltip>
  );
}

SourceLink.propTypes = {
  link: PropTypes.any,
  background: PropTypes.string,
};

SourceLink.defaultProps = {
  link: '',
  background: '#f5f5f5',
};

export default SourceLink;
